import { render, staticRenderFns } from "./ColorPickers.vue?vue&type=template&id=7adfe349&"
import script from "./ColorPickers.vue?vue&type=script&lang=js&"
export * from "./ColorPickers.vue?vue&type=script&lang=js&"
import style0 from "./ColorPickers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ColorPickers.vue"
export default component.exports